module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "编辑课前预习",
      "width": "1000px"
    },
    on: {
      "on-ok": _vm.saveData
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "previewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.previewRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本",
      "prop": "version"
    }
  }, [_c('Select', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formData.version),
      callback: function($$v) {
        _vm.$set(_vm.formData, "version", _vm._n($$v))
      },
      expression: "formData.version"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择开始Level",
      "prop": "levelId",
      "label-width": 100
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.levelTitle),
      callback: function($$v) {
        _vm.levelTitle = $$v
      },
      expression: "levelTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "选择对应课程",
      "prop": "lessonId",
      "label-width": 100
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.lessonTitle),
      callback: function($$v) {
        _vm.lessonTitle = $$v
      },
      expression: "lessonTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": true
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("预览")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('uploader', {
    staticClass: "uploader-example",
    attrs: {
      "options": _vm.options
    },
    on: {
      "file-success": _vm.uploadSucess,
      "files-added": _vm.filesAdd
    }
  }, [_c('uploader-unsupport'), _vm._v(" "), _c('uploader-drop', [_c('p', {
    staticClass: "info"
  }, [_vm._v("上传本地课前预习"), _c('span', [_vm._v("(注意将主页面改为index.html)")])]), _vm._v(" "), _c('uploader-btn', {
    attrs: {
      "directory": true
    }
  }, [_vm._v("选择一个文件夹")])], 1), _vm._v(" "), _c('uploader-list')], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a4eb168","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/course/NativeLessonPreviewUpdateModal.vue
// module id = 1900
// module chunks = 8